document.addEventListener("DOMContentLoaded", function() {
  try {
    var url = document.URL;
    var pathname = new URL(url).pathname;

    // Check if the current page is the index page
    if (
      pathname.indexOf("/") === 0 || 
      pathname.indexOf("/en") === 0
    ) {
      var logo = document.querySelector(".header__logo img");
      var header = document.querySelector(".header");
      var navWrapper = document.querySelector('.nav-wrapper');
      var isMobile = window.matchMedia("(max-width: 768px)").matches; // Check if it's a mobile device
      var logoWidth = logo.offsetWidth; // Get initial width of the logo
      var headerHeightDesktop = "auto"; // Default height for desktop
      var headerHeightMobile = "100px"; // Adjusted height for mobile
      var logoWidthDesktop = '200px'; // Default width for desktop
      var logoWidthMobile = '100px'; // Adjusted width for mobile
      
      // Set initial width of logo
      logo.style.width = logoWidth + "px";
      
      // Set initial height of header
      header.style.height = headerHeightDesktop;
      
      // Add a class to nav-wrapper before scroll
      navWrapper.classList.add('nav-pos');
      
      // Add a class to .header__logo img before scroll
      logo.classList.add('logo');

      window.addEventListener("scroll", function () {
        if (window.scrollY > 0) {
          logo.style.width = logoWidthDesktop;
          header.style.height = isMobile ? headerHeightMobile : "70px"; // Adjusted height for mobile
          navWrapper.classList.remove('nav-pos');
          logo.classList.remove('logo');
        } else {
          logo.style.width = logoWidth + "px"; // Set logo width back to initial width
          header.style.height = isMobile ? headerHeightMobile : headerHeightDesktop; // Adjusted height for mobile
          navWrapper.classList.add('nav-pos');
          logo.classList.add('logo');
        }
      });
    }
  } catch (error) {
    // Handle the error gracefully, such as logging it or providing a default behavior
    console.error("Error accessing URL:", error);
  }
});
